import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import NewsPage from './pages/NewsPage';
import AboutPage from './pages/AboutPage';
import ServicePage from './pages/ServicePage';
import CSRPage from './pages/CSRPage';
import BlogPage from './pages/BlogPage';
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';
import Placeholder from './pages/Placeholder';
import LoginPage from './pages/LoginPage';
import AuthCallback from './pages/AuthCallback';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import SetPasswordPage from './pages/SetPasswordPage';
import VerticalsPublic from './pages/VerticalsPublic';
import VerticalDetail from './pages/VerticalDetail';
import NewsroomListing from './pages/NewsroomListing';
import NewsroomDetail from './pages/NewsroomDetail';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminHome from './pages/admin/AdminHome';
import UsersAdminPage from './pages/admin/UsersAdminPage';
import NavLabelsPage from './pages/admin/NavLabelsPage';
import VerticalsAdminPage from './pages/admin/VerticalsPage';
import CompanyNewsPage from './pages/admin/CompanyNewsPage';
import SayingsPage from './pages/admin/SayingsPage';
import AboutAdminPage from './pages/admin/AboutAdminPage';
import PeopleAdminPage from './pages/admin/PeopleAdminPage';
import HomeLayoutAdminPage from './pages/admin/HomeLayoutAdminPage';
import CRMPage from './pages/admin/CRMPage';
import HRPage from './pages/admin/HRPage';
import PayrollPage from './pages/admin/PayrollPage';
import AttendancePage from './pages/admin/AttendancePage';
import TaxSlabsPage from './pages/admin/TaxSlabsPage';
import StatutoryReportsPage from './pages/admin/StatutoryReportsPage';
import LoansListPage, { LoanDetailPage } from './pages/admin/LoansPage';
import AttendanceApprovalsPage from './pages/admin/AttendanceApprovalsPage';
import PerformancePage from './pages/admin/PerformancePage';
import RecruitmentPage from './pages/admin/RecruitmentPage';
import OnboardingPage from './pages/admin/OnboardingPage';
import TeamDashboardPage from './pages/admin/TeamDashboardPage';
import LetterTemplatesPage from './pages/admin/LetterTemplatesPage';
import PayrollStatusPage from './pages/admin/PayrollStatusPage';
import AccountsQueuePage from './pages/admin/AccountsQueuePage';
import { CountriesPage, OrgHierarchyPage, EmployeeDocsPage } from './pages/admin/GlobalHRSprint1Pages';
import SelfServicePage from './pages/SelfServicePage';
import { AssetsPage, HRVendorsPage, TravelPage } from './pages/admin/GlobalHRSprint3Pages';
import { TrainingPage, PoliciesPage, OffboardingPage } from './pages/admin/GlobalHRSprint4Pages';
import ApprovalsInboxPage from './pages/admin/ApprovalsInboxPage';
import ManagementDashboardV2 from './pages/admin/ManagementDashboardV2';
import { BenefitsPage, PromotionsPage, TransfersPage, OvertimePage } from './pages/admin/HRPeopleOpsPages';
import { DisciplinePage, SafetyPage, AuditLogPage, RemindersPage } from './pages/admin/HRCompliancePages';
import { OfficeAdminPage, ReportsPage, MigrationPage, AccessMatrixPage } from './pages/admin/HRAdminOpsPages';
import LeadsPage from './pages/admin/LeadsPage';
import MyDayPage from './pages/admin/MyDayPage';
import WorkloadPage from './pages/admin/WorkloadPage';
import MastersPage from './pages/admin/MastersPage';
import BooksLinkPage from './pages/admin/BooksLinkPage';
import BroadcastsPage from './pages/admin/BroadcastsPage';
import CalendarPage from './pages/admin/CalendarPage';
import { GalleriesListPage, GalleryDetailPage } from './pages/admin/GalleriesPage';
import PublicGalleryPage from './pages/PublicGalleryPage';
import PublicGalleriesListPage from './pages/PublicGalleriesListPage';

// ---- Emerald Books (isolated module) ----
import BooksLayout from './books/BooksLayout';
import BooksLandingPage from './books/LandingPage';
import BooksPricingPage from './books/PricingPage';
import BooksSignupPage from './books/BooksSignupPage';
import BooksLoginPage from './books/BooksLoginPage';
import BooksForgotPasswordPage from './books/BooksForgotPasswordPage';
import BooksResetPasswordPage from './books/BooksResetPasswordPage';
import BooksBillingPage from './books/BillingPage';
import BooksDashboardPage from './books/DashboardPage';
import {
  ApiKeysPage,
  WebhooksPage,
  BackupPage,
  ComingSoonPage,
} from './books/Phase89Pages';
import { RecurringPage, BankReconPage, StatementsPage } from './books/SalesOpsPages';
import { PayrollEmployeesPage, PayrollRunsPage } from './books/PayrollPages';
import { InventoryItemsPage, StockLevelsPage } from './books/InventoryPages';
import { QuotesPage, PurchaseOrdersPage } from './books/PreSalesPages';
import BudgetsPage from './books/BudgetsPage';
import BranchesPage from './books/BranchesPage';
import BooksProtectedRoute from './books/BooksProtectedRoute';
import { CRMTasksPage, CRMTicketsPage } from './books/CRMPages';
import { HREmployeesPage, HRPoliciesPage, HROrgChartPage } from './books/HRPages';
import { LeaveRequestsPage, LeaveBalancePage, LeaveTypesPage } from './books/LeavePages';
import ConsolidationPage from './books/ConsolidationPage';
import ESSHomePage from './books/ESSPortal';
import { PeriodClosePage, ApprovalsPage } from './books/GovernancePages';
import RevRecSchedulesPage from './books/RevRecPage';
import { DepartmentsPage, ProjectsPage, DimensionMatrixPage } from './books/DimensionsPages';
import { Shield, Bell } from 'lucide-react';
import BooksAccountsPage from './books/AccountsPage';
import BooksJournalsPage from './books/JournalsPage';
import BooksContactsPage from './books/ContactsPage';
import BooksDocumentsPage from './books/DocumentsPage';
import { AgingPage, ExpensesPage } from './books/AgingAndExpensesPages';
import { TrialBalancePage, ProfitLossPage, BalanceSheetPage, CashFlowPage } from './books/ReportsPages';
import FxRatesPage from './books/FxRatesPage';
import FixedAssetsPage from './books/FixedAssetsPage';
import TaxReturnsPage from './books/TaxReturnsPage';
import CsvImportPage from './books/CsvImportPage';
import CostCentresPage from './books/CostCentresPage';
import LeadershipPage from './pages/LeadershipPage';
import PersonPage from './pages/PersonPage';
import BlogPostPage from './pages/BlogPostPage';
import AuthorLoginPage from './pages/AuthorLoginPage';
import AuthorDashboardPage from './pages/AuthorDashboardPage';
import ProtectedRoute from './components/ProtectedRoute';
import InstallBanner from './components/InstallBanner';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';
import { Toaster as SonnerToaster } from 'sonner';

const AppRouter = () => {
  // Detect session_id in URL fragment BEFORE ProtectedRoute runs.
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/services" element={<ServicePage />} />
      <Route path="/services/:slug" element={<ServicePage />} />
      <Route path="/verticals" element={<VerticalsPublic />} />
      <Route path="/verticals/:slug" element={<VerticalDetail />} />
      <Route path="/news" element={<NewsPage />} />
      <Route path="/newsroom" element={<NewsroomListing />} />
      <Route path="/newsroom/:slug" element={<NewsroomDetail />} />
      <Route path="/leadership" element={<LeadershipPage />} />
      <Route path="/people/:slug" element={<PersonPage />} />
      <Route path="/people/:slug/blog/:postSlug" element={<BlogPostPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/csr" element={<CSRPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/gallery/:slug" element={<PublicGalleryPage />} />
      <Route path="/galleries" element={<PublicGalleriesListPage />} />
      <Route path="/galleries/:slug" element={<PublicGalleryPage />} />

      {/* Author (per-person blog) */}
      <Route path="/author/login" element={<AuthorLoginPage />} />
      <Route path="/author" element={<AuthorDashboardPage />} />

      {/* Auth — /login is the unified surface; :mode picks Admin vs Employee tab preselection */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/:mode" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/set-password" element={<SetPasswordPage mode="invite" />} />
      <Route path="/reset-password" element={<SetPasswordPage mode="reset" />} />

      {/* ---- Employee Self-Service Portal (Sprint 2) ---- */}
      <Route path="/hr/me" element={<ProtectedRoute><SelfServicePage /></ProtectedRoute>} />

      {/* Admin (protected) — any authenticated user can enter the shell; per-route role gates below */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminHome />} />
        <Route path="verticals" element={<ProtectedRoute roles={['super_admin', 'admin', 'content_publisher']}><VerticalsAdminPage /></ProtectedRoute>} />
        <Route path="news" element={<ProtectedRoute roles={['super_admin', 'admin', 'content_publisher']}><CompanyNewsPage /></ProtectedRoute>} />
        <Route path="sayings" element={<ProtectedRoute roles={['super_admin', 'admin', 'content_publisher']}><SayingsPage /></ProtectedRoute>} />
        <Route path="about" element={<ProtectedRoute roles={['super_admin', 'admin', 'content_publisher']}><AboutAdminPage /></ProtectedRoute>} />
        <Route path="home" element={<ProtectedRoute roles={['super_admin', 'admin', 'content_publisher']}><HomeLayoutAdminPage /></ProtectedRoute>} />
        <Route path="people" element={<ProtectedRoute roles={['super_admin', 'admin', 'content_publisher']}><PeopleAdminPage /></ProtectedRoute>} />
        <Route path="crm" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff']}><CRMPage /></ProtectedRoute>} />
        <Route path="hr" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff']}><HRPage /></ProtectedRoute>} />
        <Route path="payroll" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff']}><PayrollPage /></ProtectedRoute>} />
        <Route path="attendance" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff']}><AttendancePage /></ProtectedRoute>} />
        <Route path="attendance-approvals" element={<ProtectedRoute roles={['super_admin', 'admin']}><AttendanceApprovalsPage /></ProtectedRoute>} />
        <Route path="tax-slabs" element={<ProtectedRoute roles={['super_admin', 'admin']}><TaxSlabsPage /></ProtectedRoute>} />
        <Route path="statutory-reports" element={<ProtectedRoute roles={['super_admin', 'admin']}><StatutoryReportsPage /></ProtectedRoute>} />
        <Route path="loans" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff']}><LoansListPage /></ProtectedRoute>} />
        <Route path="loans/:id" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff']}><LoanDetailPage /></ProtectedRoute>} />
        <Route path="performance" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff']}><PerformancePage /></ProtectedRoute>} />
        <Route path="recruitment" element={<ProtectedRoute roles={['super_admin', 'admin']}><RecruitmentPage /></ProtectedRoute>} />
        <Route path="onboarding" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><OnboardingPage /></ProtectedRoute>} />
        <Route path="team" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff']}><TeamDashboardPage /></ProtectedRoute>} />
        <Route path="letter-templates" element={<ProtectedRoute roles={['super_admin', 'admin']}><LetterTemplatesPage /></ProtectedRoute>} />
        <Route path="payroll-status" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><PayrollStatusPage /></ProtectedRoute>} />
        <Route path="accounts-queue" element={<ProtectedRoute roles={['super_admin', 'admin', 'accounts']}><AccountsQueuePage /></ProtectedRoute>} />
        {/* Global HR — Sprint 1 · Org Foundation */}
        <Route path="countries" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><CountriesPage /></ProtectedRoute>} />
        <Route path="org-hierarchy" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><OrgHierarchyPage /></ProtectedRoute>} />
        <Route path="employee-docs" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><EmployeeDocsPage /></ProtectedRoute>} />
        {/* Global HR — Sprint 3 · Assets · Vendors · Travel */}
        <Route path="assets" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><AssetsPage /></ProtectedRoute>} />
        <Route path="hr-vendors" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><HRVendorsPage /></ProtectedRoute>} />
        <Route path="travel" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff', 'hr']}><TravelPage /></ProtectedRoute>} />
        {/* Global HR — Sprint 4 · Training · Policies · Offboarding */}
        <Route path="training" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr', 'staff']}><TrainingPage /></ProtectedRoute>} />
        <Route path="policies" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr', 'staff']}><PoliciesPage /></ProtectedRoute>} />
        <Route path="offboarding" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><OffboardingPage /></ProtectedRoute>} />
        <Route path="approvals-inbox" element={<ProtectedRoute><ApprovalsInboxPage /></ProtectedRoute>} />
        {/* Global HR — Mega batch */}
        <Route path="mgmt-dashboard" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr', 'accounts']}><ManagementDashboardV2 /></ProtectedRoute>} />
        <Route path="benefits" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><BenefitsPage /></ProtectedRoute>} />
        <Route path="promotions" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><PromotionsPage /></ProtectedRoute>} />
        <Route path="transfers" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><TransfersPage /></ProtectedRoute>} />
        <Route path="overtime" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr', 'staff']}><OvertimePage /></ProtectedRoute>} />
        <Route path="discipline" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><DisciplinePage /></ProtectedRoute>} />
        <Route path="safety" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><SafetyPage /></ProtectedRoute>} />
        <Route path="audit-log" element={<ProtectedRoute roles={['super_admin', 'admin']}><AuditLogPage /></ProtectedRoute>} />
        <Route path="reminders" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><RemindersPage /></ProtectedRoute>} />
        <Route path="office-admin" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><OfficeAdminPage /></ProtectedRoute>} />
        <Route path="hr-reports" element={<ProtectedRoute roles={['super_admin', 'admin', 'hr']}><ReportsPage /></ProtectedRoute>} />
        <Route path="migration" element={<ProtectedRoute roles={['super_admin', 'admin']}><MigrationPage /></ProtectedRoute>} />
        <Route path="access-matrix" element={<ProtectedRoute roles={['super_admin', 'admin']}><AccessMatrixPage /></ProtectedRoute>} />        <Route path="leads" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff']}><LeadsPage /></ProtectedRoute>} />
        <Route path="my-day" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff']}><MyDayPage /></ProtectedRoute>} />
        <Route path="workload" element={<ProtectedRoute roles={['super_admin', 'admin']}><WorkloadPage /></ProtectedRoute>} />
        <Route path="broadcasts" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff']}><BroadcastsPage /></ProtectedRoute>} />
        <Route path="calendar" element={<ProtectedRoute roles={['super_admin', 'admin', 'staff']}><CalendarPage /></ProtectedRoute>} />
        <Route path="galleries" element={<ProtectedRoute roles={['super_admin', 'admin', 'content_publisher']}><GalleriesListPage /></ProtectedRoute>} />
        <Route path="galleries/:gallery_id" element={<ProtectedRoute roles={['super_admin', 'admin', 'content_publisher']}><GalleryDetailPage /></ProtectedRoute>} />
        <Route path="masters" element={<ProtectedRoute roles={['super_admin', 'admin']}><MastersPage /></ProtectedRoute>} />
        <Route path="users" element={<ProtectedRoute roles={['super_admin']}><UsersAdminPage /></ProtectedRoute>} />
        <Route path="nav-labels" element={<ProtectedRoute roles={['super_admin']}><NavLabelsPage /></ProtectedRoute>} />
        <Route path="books-link" element={<ProtectedRoute roles={['super_admin', 'admin']}><BooksLinkPage /></ProtectedRoute>} />
        <Route path="inbox" element={<ProtectedRoute roles={['super_admin', 'admin', 'content_publisher']}><AdminPage embedded /></ProtectedRoute>} />
      </Route>

      {/* ---- Emerald Books (independent app slice — own auth via `books_token`) ---- */}
      <Route path="/books" element={<BooksLandingPage />} />
      <Route path="/books/pricing" element={<BooksPricingPage />} />
      <Route path="/books/signup" element={<BooksSignupPage />} />
      <Route path="/books/login" element={<BooksLoginPage />} />
      <Route path="/books/forgot-password" element={<BooksForgotPasswordPage />} />
      <Route path="/books/reset-password" element={<BooksResetPasswordPage />} />
      <Route path="/books/app" element={<BooksProtectedRoute><BooksLayout /></BooksProtectedRoute>}>
        <Route index element={<BooksDashboardPage />} />
        <Route path="dashboard" element={<BooksDashboardPage />} />
        <Route path="billing" element={<BooksBillingPage />} />
        <Route path="accounts" element={<BooksAccountsPage />} />
        <Route path="journals" element={<BooksJournalsPage />} />
        <Route path="customers" element={<BooksContactsPage type="customer" />} />
        <Route path="vendors" element={<BooksContactsPage type="vendor" />} />
        <Route path="invoices" element={<BooksDocumentsPage />} />
        <Route path="bills" element={<BooksDocumentsPage />} />
        <Route path="expenses" element={<ExpensesPage />} />
        <Route path="fixed-assets" element={<FixedAssetsPage />} />
        <Route path="fx-rates" element={<FxRatesPage />} />
        <Route path="cost-centres" element={<CostCentresPage />} />
        <Route path="tax-returns" element={<TaxReturnsPage />} />
        <Route path="csv-import" element={<CsvImportPage />} />
        <Route path="reports/trial-balance" element={<TrialBalancePage />} />
        <Route path="reports/profit-loss" element={<ProfitLossPage />} />
        <Route path="reports/balance-sheet" element={<BalanceSheetPage />} />
        <Route path="reports/cash-flow" element={<CashFlowPage />} />
        <Route path="reports/aging-receivables" element={<AgingPage />} />
        <Route path="reports/aging-payables" element={<AgingPage />} />
        <Route path="reports/dashboard" element={<BooksDashboardPage />} />
        {/* Phase 8 & 9 modules */}
        <Route path="inventory" element={<InventoryItemsPage />} />
        <Route path="stock-levels" element={<StockLevelsPage />} />
        <Route path="quotes" element={<QuotesPage />} />
        <Route path="purchase-orders" element={<PurchaseOrdersPage />} />
        <Route path="payroll/employees" element={<PayrollEmployeesPage />} />
        <Route path="payroll/runs" element={<PayrollRunsPage />} />
        <Route path="budgets" element={<BudgetsPage />} />
        <Route path="branches" element={<BranchesPage />} />
        <Route path="api-keys" element={<ApiKeysPage />} />
        <Route path="webhooks" element={<WebhooksPage />} />
        <Route path="backup" element={<BackupPage />} />
        <Route path="recurring" element={<RecurringPage />} />
        <Route path="bank-recon" element={<BankReconPage />} />
        <Route path="statements" element={<StatementsPage />} />
        <Route path="2fa" element={<ComingSoonPage title="Two-Factor Auth" hint="POST /api/books/settings/2fa/setup" icon={Shield} />} />
        <Route path="notifications" element={<ComingSoonPage title="Notifications" hint="GET /api/books/settings/notifications" icon={Bell} />} />
        {/* Phase 10 — CRM · HR · Leave · Consolidation · ESS */}
        <Route path="me" element={<ESSHomePage />} />
        <Route path="crm/tasks" element={<CRMTasksPage />} />
        <Route path="crm/tickets" element={<CRMTicketsPage />} />
        <Route path="hr/employees" element={<HREmployeesPage />} />
        <Route path="hr/policies" element={<HRPoliciesPage />} />
        <Route path="hr/org-chart" element={<HROrgChartPage />} />
        <Route path="leave/requests" element={<LeaveRequestsPage />} />
        <Route path="leave/balance" element={<LeaveBalancePage />} />
        <Route path="leave/types" element={<LeaveTypesPage />} />
        <Route path="consolidation" element={<ConsolidationPage />} />
        <Route path="period-close" element={<PeriodClosePage />} />
        <Route path="approvals" element={<ApprovalsPage />} />
        <Route path="rev-rec" element={<RevRecSchedulesPage />} />
        <Route path="departments" element={<DepartmentsPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="reports/matrix" element={<DimensionMatrixPage />} />
      </Route>
      {/* Legacy redirect: keep /books/dashboard working */}
      <Route path="/books/dashboard" element={<BooksProtectedRoute><BooksLayout /></BooksProtectedRoute>}>
        <Route index element={<BooksDashboardPage />} />
      </Route>

      <Route path="*" element={<Placeholder />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <InstallBanner />
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
      <SonnerToaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
